import React from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from "redux";

import {fetchLastTopics} from '../../../../creators/home.lastTopics';

import Carousel from '../../../components/Carousel';
import ForumCard from './ForumCard';

class ForumHome extends React.Component {

    componentWillMount() {
        this.props.fetchLastTopics();
    }


    render() {
        return (
            <Carousel>
                <div className="pane">
                    <div className="row">
                        {this.props.topicsInitialized && this.props.topics && this.props.topics.slice(0, 4).map((article) => (
                            <ForumCard
                                key={article._id}
                                {...article}
                            />
                        ))}
                    </div>
                    <div className="row">
                        {this.props.topicsInitialized && this.props.topics && this.props.topics.slice(4, 8).map((article) => (
                            <ForumCard
                                key={article._id}
                                {...article}
                            />
                        ))}
                    </div>
                </div>
                <div className="pane">
                    <div className="row">
                        {this.props.topicsInitialized && this.props.topics && this.props.topics.slice(8, 12).map((article) => (
                            <ForumCard
                                key={article._id}
                                {...article}
                            />
                        ))}
                    </div>
                    <div className="row">
                        {this.props.topicsInitialized && this.props.topics && this.props.topics.slice(12, 16).map((article) => (
                            <ForumCard
                                key={article._id}
                                {...article}
                            />
                        ))}
                    </div>
                </div>
            </Carousel>
        )
    }
}


const mapStateToProps = (state) => {
    return {
        topics: state.homeLastTopics.data,
        topicsLoading: state.homeLastTopics.loading,
        topicsInitialized: state.homeLastTopics.initialized,
    }
};

const mapDispatchToProps = (dispatch) => bindActionCreators({
    fetchLastTopics
}, dispatch);


export default connect(mapStateToProps, mapDispatchToProps)(ForumHome);
